import {SxProps, Typography} from '@mui/material';
import pkg from '../../../package.json';

type AppVersionTextProps = {
  sx?: SxProps;
  className?: string;
};

export function AppVersionText(props: AppVersionTextProps) {
  return (
    <Typography
      variant="caption"
      color="GrayText"
      className={props.className}
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'row-reverse',
        ...props.sx,
      }}
    >
      v{pkg.version}
    </Typography>
  );
}
